import type { ComputedRef, Ref } from 'vue'
import type { OrderPayment } from '@widgets/orders'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from '@shared/lib/format'

import { useOrderStore } from './store'

const EMPTY_TYPE = '---'

interface OrderPaymentLogReturn {
  refPayments: ComputedRef<OrderPayment[]>
  hasPayments: ComputedRef<boolean>
  refIsOpen: Ref<boolean>
  toggle: () => void
  getType: (payment: OrderPayment) => string
  formatDate: (value: string) => string
  openChangelog: (payment: OrderPayment) => void
}

/** The "Payment log" card: collapsed by default, one row per provider payment attempt. */
export const useOrderPaymentLog = (): OrderPaymentLogReturn => {
  const orderStore = useOrderStore()
  const dayjs = useDayjs()

  const refIsOpen = ref<boolean>(false)

  const refPayments = computed<OrderPayment[]>(() => orderStore.getOrder?.payments ?? [])
  const hasPayments = computed<boolean>(() => refPayments.value.length > 0)

  const toggle = (): void => {
    refIsOpen.value = !refIsOpen.value
  }

  const getType = (payment: OrderPayment): string => payment.type || EMPTY_TYPE

  const formatDate = (value: string): string => dayjs(value).format(DateFormat.KanbanDate)

  const openChangelog = (payment: OrderPayment): void => {
    orderStore.setChangelogPayment(payment)
  }

  return {
    refPayments,
    hasPayments,
    refIsOpen,
    toggle,
    getType,
    formatDate,
    openChangelog,
  }
}
